// profileActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import UserProfileAPI from './profileAPI';
import { clearAuth } from '../../authentication/utils/core/authslice'; // adjust path if different

export const fetchUserProfile = createAsyncThunk(
  'userProfile/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const data = await UserProfileAPI.fetch();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load profile');
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'userProfile/update',
  async (userData, { rejectWithValue }) => {
    try {
      const data = await UserProfileAPI.update(userData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update profile');
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  'userProfile/changePassword',
  async (passwordData, { rejectWithValue }) => {
    try {
      await UserProfileAPI.changePassword(passwordData); // no payload expected
      return true; // signal success
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to change password');
    }
  }
);

export const logoutUser = createAsyncThunk(
  'userProfile/logout',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      await UserProfileAPI.logout();
      dispatch(clearAuth());
      return true;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to logout');
    }
  }
);
